import { cn } from '../../lib/utils';

export const EmptyState = ({ icon: Icon, title, description, action, className }) => {
    return (
        <div 
            className={cn(
                'flex flex-col items-center justify-center py-16 px-4 text-center',
                className
            )}
            data-testid="empty-state"
        >
            {Icon && (
                <div className="w-16 h-16 bg-muted rounded-sm flex items-center justify-center mb-4">
                    <Icon className="w-8 h-8 text-muted-foreground" />
                </div>
            )}
            <h3 className="text-lg font-semibold uppercase tracking-wide mb-2" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                {title}
            </h3>
            {description && (
                <p className="text-sm text-muted-foreground mb-6 max-w-sm">
                    {description}
                </p>
            )}
            {action}
        </div>
    );
};
